import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";

import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import { ContactWithID, ContactWithOutID} from '../../types/request.type';

export const contactsData3 = createAsyncThunk<ContactWithID[], void>(
  "/contactsData3",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

  //  console.log("contactsData");

    try {

      const response = await api.get(`/contacts`, {
        params: {
          //client: client.id,
          page: 1,
          qtyPerPage: 1000

        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }


   //   console.log(response.data);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);




export const contactsData30 = createAsyncThunk<ContactWithID[], void>(
  "/contactsData30",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

  //  console.log("contactsData");
    //console.log(client.id);

    try {

      const response = await api.get(`/contacts`, {
        params: {
          //client: client.id,
          page: 1,
          qtyPerPage: 1000

        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

     // console.log("export const contactsData30");
    //  console.log(response.data);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);




export const contactsDataPost3 = createAsyncThunk<ContactWithID, ContactWithOutID>(
  "/contactsDataPost3",
  async (new_contact, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

   // console.log("contactsDataPost");
   // console.log(new_contact.client.id + " " + new_contact.name + "  " + new_contact.phones + "  " + new_contact.emails + "  " + new_contact.position + "  " + new_contact.comment);

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization" : `Bearer ${accessToken}`,
      },
       
    };

    try {

      const response = await api.post(`/contacts`, {
                      
          name: new_contact.name,
          client: new_contact.client,
          phones: new_contact.phones,
          emails: new_contact.emails,
          position: new_contact.position,
          comment: new_contact.comment
        ,
      }, config);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);



export const contactsDataUpdate3 = createAsyncThunk<ContactWithID, ContactWithID>(
  "/contacstDataUpdate3",
  async (update_contact, { rejectWithValue, fulfillWithValue }) => {
    //

    //("contactsDataUpdate");
    //console.log(update_contact?.client.id + " " + update_contact?.id + "  " + update_contact?.name + "  " + update_contact?.phones + "  " + update_contact?.emails + "  " + update_contact?.position + "  " + update_contact?.comment);

    const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
   : null
    try {
      // configure header's Content-Type as JSON
        const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${accessToken}`,
        },
         
      };

      const databody = {
        //title: title, // This is the body part
        name: update_contact?.name,
        client_id: update_contact?.client.id,
        phones: update_contact?.phones,
        emails: update_contact?.emails,
        position: update_contact?.position,
        comment: update_contact?.comment
      };
   
     // console.log(databody);

     const response = await api.patch(`/contacts/${update_contact?.id}`, databody, config);
     
     return fulfillWithValue(response.data);

    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);



export const contactsDataDelete3 = createAsyncThunk<SuccessResponse, ContactWithID>(
  "/contactsDataDelete3",
  async (delete_contact, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
   : null
    try {
      // configure header's Content-Type as JSON
        const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${accessToken}`,
        },
         
      };
   
      const response = await api.delete(`/contacts/${delete_contact?.id}`, config);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);